module.exports = __webpack_public_path__ + "img/huace2.22ba44d1.jpg";